module.exports = __webpack_public_path__ + "static/assets/171fbf8ebb9d7127d4c59a04568e2af4.svg";